<template>
  <div :class="rootClass">
    <div class="feature-card">
      <div class="card-body">
        <div class="title-4">
          {{ title }}
        </div>
        <div class="description">
          <div v-for="description in descriptions" :key="description">
            {{ description }}
          </div>
        </div>
      </div>
      <div class="footer">
        <img
          v-lazy-load :data-src="footer.image"
          class="fir-author-image fir-clickcircle"
          alt=""
        />
        <div class="fir-imageover-color">
          <div class="name">
            <b>{{ footer.name }}</b>
          </div>
          <div class="fig-author-figure-title profession">
            {{ footer.profession }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { object } from 'space-lift/commonjs/object/is';
import deviceMixin from "~/mixins/deviceMixin";

export default {
  mixins: [deviceMixin],
  props: {
    title: String,
    descriptions: Array,
    link: String,
    footer: Object,
    id: String
  },
  computed: {
    rootClass() {
      switch (this.$mq) {
        case "desktop":
          return "feature-card-wrapper card-wrapper";
        case "tablet":
          return "feature-card-wrapper card-wrapper";
        default:
          return "feature-card-wrapper-mobile card-wrapper";
      }
    },
    description() {
      switch (this.$mq) {
        case "desktop":
          return "descrpt";
        default:
          return "description-mobile";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
%card-wrapper {
  height: 100%;
  display: flex;
  margin: auto;
}

.feature-card-wrapper {
  @extend %card-wrapper;

  align-content: center;
  max-width: 95%;
  border-radius: 5px;
}

.card-wrapper {
  .feature-card {
    background: white;
    max-width: 100%;
    max-height: 70%;
    display: flex;
    flex-direction: column;
    border-radius: 5px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    img {
      max-width: 100%;
      border: 3px solid $primary-yellow;
    }

    .card-body {
      display: flex;
      flex-direction: column;
      padding: 1rem;
    }
    .footer {
      display: flex;
      justify-content: left;
      padding: 1rem;
      padding-top: 0;
      align-items: center;

      .fir-clickcircle {
        height: 60px;
        width: 60px;
        border-radius: 100px;
        margin-right: 1rem;
      }

      .name {
        font-weight: 600;
        font-size: 16px;
        line-height: 20.93px;
        letter-spacing: 0.03px;
      }
    }

    .description-4 {
      line-height: $description-4-base + 4px;
      margin-top: 0.5rem;

      div {
        display: flex;

        span {
          margin-left: 1rem;
        }
      }
    }
  }
  &.feature-card-wrapper {
    @extend %card-wrapper;

    .description {
      font-weight: 600;
      font-size: 18px;
      line-height: 23.54px;
      letter-spacing: 0.03px;
      text-justify: inter-character;
    }

    .footer {
      .profession {
        font-weight: 400;
        font-size: 16px;
        line-height: 1.2rem;
        letter-spacing: 0.03px;
      }
    }
  }
  &.feature-card-wrapper-mobile {
    @extend %card-wrapper;

    max-width: 100%;
    margin: 0 !important;
    margin-bottom: 1rem !important;
    min-width: 100%;
    .description {
      font-weight: 400;
      font-size: 18px;
      line-height: 23.54px;
      letter-spacing: 0.03px;
      text-justify: inter-character;
    }
    .footer {
      .profession {
        font-weight: 400;
        font-size: 14px;
        line-height: 18.31x;
        letter-spacing: 0.03px;
      }
    }
  }
}
</style>
